export const getDisplayTime = (drawDate) => {
  const date = new Date(drawDate);
  return date
    .toLocaleTimeString("default", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toUpperCase();
};

export const getDisplayDate = (drawDate) => {
  const date = new Date(drawDate);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  return `${day < 10 ? `0${day}` : day} ${month} ${year}`;
};

export const getDisplayDateTime = (drawDate) => {
  return `${getDisplayDate(drawDate)} @ ${getDisplayTime(drawDate)}`;
};
